import { useParams } from "react-router-dom"
import Layout from "../../../components/Frames/Layout"
import {Courses as API} from "../../../services/API/Courses"
import { useEffect, useState } from "react"
import { Alert, TextField, TableContainer, Table, TableHead, TableBody, TableRow, TableCell, Paper, Stack, CircularProgress } from "@mui/material"
import Toast from "../../../components/Tools/Toast"
import Tip from "../../../components/Tools/Tip"

export default function Form(){

    const [course, setCourse] = useState(false)
    const [questions, setQuestions] = useState([])
    const [error, setError] = useState(false)
    const [current, setCurrent] = useState({k: -1, v: ''})
    const {id} = useParams()

    useEffect(() => {

        API.getOne(id)
            .then(r => {
                setCourse(r.data);
                return setQuestions(r.data.audit || [])
            })
            .catch(e => setError(true))

    }, [id])

    const handleSubmit = e => {
        e.preventDefault();
        let copy = [...questions];
        if(current.k < 0 && questions.length < 20){
            copy.push(current.v);
        }else{
            copy[current.k] = current.v;
        }
        save(copy);
        return setCurrent({k: -1, v: ''});
    }

    const handleDelete = k => {
        let copy = [...questions];
        copy.splice(k, 1);
        save(copy);
        return setCurrent({k: -1, v: ''});
    }

    const handleSort = (k, n, val) => {
        let copy = [...questions];
        if(k + n >= 0 && k < questions.length){
            copy.splice(k, 1);
            copy.splice(k + n, 0, val);
        }
        return save(copy);
    }

    const save = data => {
        API.putAudit(course.id, data)
            .then(r => false)
            .catch(e => {
                setError(true);
                return setQuestions([...questions])
            })

        return setQuestions(data);
    }

    return <Layout title="Grille d'audit" tab="courses" menu="admin" back={true}>

        <Toast
            open={error} 
            severity='error' 
            duration={5000} 
            onClose={() => setError(false)}
            message="Une erreur s'est produite"
        />

        <h3>{course?.title}</h3>

        {questions.length > 0 && 
            <TableContainer component={Paper}>
                    <Table>
                        <TableHead>
                            <TableRow>
                                <TableCell><b>Questions</b></TableCell>
                                <TableCell></TableCell>
                            </TableRow>
                        </TableHead>
                        <TableBody>

                            {questions.map((v,k)  => k !== current.k && <TableRow key={k}>
                                    <TableCell>{k + 1}. {v}</TableCell>
                                    <TableCell>
                                        <Stack direction='row' justifyContent='end'>
                                            <Tip type='up' onClick={() => handleSort(k, -1, v)} />
                                            <Tip type='down' onClick={() => handleSort(k, 1, v)} />
                                            <Tip type='edit' onClick={() => setCurrent({k: k, v: v})} />
                                            <Tip type='delete' onClick={() => handleDelete(k)} />
                                        </Stack>
                                    </TableCell>
                                </TableRow>
                            )}

                        </TableBody>
                    </Table>
                </TableContainer>
        }


        <form onSubmit={e => handleSubmit(e)}>
            <TextField 
                value={current.v}
                onChange={e => setCurrent({k: current.k, v: e.target.value})}
                label={current.k < 0 ? 'Ajouter des questions' : 'Modifier la question'}
                inputProps={{minLength: 5, maxLength: 500}}
                size='small'
                autoFocus
                required
                sx={{mt: 2, mb: 2}}
                fullWidth
            />
        </form>

            

            {!questions.length &&
                <Alert sx={{mt: 1}} severity='info'>La grille d'audit sera automatiquement insérée dans le plan de la formation une fois que vous aurez écrit les questions.</Alert>
            }

            {!course && <Stack direction='row' justifyContent='center' style={{margin: 20}}>
                <CircularProgress size={24} />
            </Stack>}

    </Layout>
}

